module.exports = __webpack_public_path__ + "static/media/portalMagicWand.46a9b3fd.webp";